/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Zhanglei
 * @Date: 2020-08-18 13:56:13
 * @LastEditTime: 2020-08-21 15:01:43
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/store/modules/permission.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getPermissionData,
  createPermission,
  editPermission,
  getPermissionInfo,
  deletePermission
} from "@/service/permissionService";
const permission = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * 获取Permission列表
     */
    getPermissionData(store, info) {
      return new Promise((resolve, reject) => {
        getPermissionData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 创建Permission
     * @param {*} store
     * @param {*} data
     */
    createPermission(store, data) {
      return new Promise((resolve, reject) => {
        createPermission(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取Permission详情
     * @param {*} store
     * @param {*} id
     */
    getPermissionInfo(store, id) {
      return new Promise((resolve, reject) => {
        getPermissionInfo(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 编辑Permission
     * @param {*} store
     * @param {*} data
     */
    editPermission(store, data) {
      return new Promise((resolve, reject) => {
        editPermission(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除Permission
     * @param {*} store
     * @param {*} id
     */
    deletePermission(store, id) {
      return new Promise((resolve, reject) => {
        deletePermission(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js